<template>
	<div>
		<div class="flex xs-between mt6">
			<div class="fs4 lh125 fw7 c1 mb2">{{ $t("relationships") }}</div>
			<j-button
				v-if="hasActions"
				type="tertiary"
				@click="handleAdd()"
				v-can="'writeLinks'"
			>
				<crm-icon name="add" color="c2" size="small" />
				{{ $t("add") }}
			</j-button>
		</div>
		<div v-if="!inlineAdd">
			<j-card class="bg5 mb2" v-for="(item, i) in relationships" :key="i">
				<div class="flex xs-12 p3">
					<!-- This is ugly fix for digitalBroker -->
					<router-link
						class="xs-5"
						v-if="
							tenantId === 'digitalBroker' || tenantId === 'companyCover_uat'
						"
						:to="`/${$route.params.tenantId}/organizations/detail/${item.id}`"
					>
						{{ item.entityName || "----" }}
					</router-link>
					<router-link
						class="xs-5"
						v-else-if="tenantId === 'apeiron_uat'"
						:to="{
							name: 'InternalsDetail',
							params: { id: item.id }
						}"
					>
						<span class="fs3 fw7 c2">{{ item.entityName || "----" }}</span>
					</router-link>
					<p v-else class="flex xs-5 fs3 fw7 c2">
						{{ item.entityName }}
					</p>

					<!-- TODO: We will need to have better way of handling this -->

					<p class="flex xs-5 xs-right fs3 fw7 c6">{{ item.type }}</p>
					<div v-if="hasActions" class="flex xs-2 xs-right xs-middle">
						<j-button
							type="tertiary"
							@click="handleDelete(item)"
							v-can="'writeLinks'"
						>
							<crm-icon name="delete" color="cError" size="small" />
						</j-button>
					</div>
				</div>
			</j-card>

			<!-- If no data -->
			<j-card v-if="relationships.length === 0" class="mb2 bg5 p2 ta2 fs3 c1">{{
				$t("errors.no_data")
			}}</j-card>
		</div>

		<!-- Add Modal -->
		<core-modal :name="`addRelationship`" :headline="$t('add_relationship')">
			<div class="p4">
				<div>
					<entity-add-relationship
						:sourceId="sourceId"
						@added="
							$emit('added')
							$modal.hide('addRelationship')
						"
					/>
				</div>
			</div>
		</core-modal>

		<!-- Inline Add -->
		<div v-if="inlineAdd" class="bg4 r2 bc7 b1">
			<div class="flex xs-between p2 xs-12">
				<div class="fw7 fs3 c1">{{ $t("add_relationship") }}</div>
				<crm-icon
					size="small"
					color="c1"
					name="cross"
					class="cu2"
					@click.native="inlineAdd = false"
				/>
			</div>
			<entity-add-relationship
				class="p4"
				:sourceId="sourceId"
				size="small"
				fsLabel="fs3"
				@added="
					$emit('added')
					$modal.hide('addRelationship')
				"
			/>
		</div>
	</div>
</template>

<script>
import JCard from "@/components/JCard/"
import JList from "@/components/JList/"
import JButton from "@/components/JButton/"
import CrmIcon from "@/components/CrmIcon/"
import JExpendableBox from "@/components/JExpendableBox/"
import dayjs from "dayjs"
import api from "@/modules/core/api/"
import CoreModal from "@/modules/core/components/CoreModal"
import EntityAddRelationship from "./EntityAddRelationship"

export default {
	props: {
		relationships: Array,
		hasActions: Boolean,
		sourceId: String,
		mode: String
	},

	data() {
		return {
			inlineAdd: false
		}
	},

	computed: {
		tenantId() {
			return this.$store.state.tenantId
		}
	},

	components: {
		JCard,
		JList,
		JButton,
		CrmIcon,
		JExpendableBox,
		CoreModal,
		EntityAddRelationship
	},

	methods: {
		handleAdd() {
			if (this.mode === "modal") this.$modal.show(`addRelationship`)
			if (this.mode === "inline") this.inlineAdd = !this.inlineAdd
		},

		async handleDelete(payload) {
			const res = await api.removeLink({
				linkInput: {
					sourceId: this.sourceId,
					link: payload.type,
					targetId: payload.id
				}
			})

			// Error
			if (res.errors) {
				this.$store.dispatch("showError", res.errors)
			}

			this.$emit("deleted")
		}
	}
}
</script>
